<template>
  <table-component
    ref="weekTable"
    :data="data"
    :show-caption="false"
    class="datatable"
    sort-by="id"
    sort-order="asc"
    :show-filter="false"
  >
    <table-column show="id" label="Id" :hidden="true"></table-column>
    <table-column
      show="type"
      :label="$t('health.nutritionalPlan.meal')"
      header-class="text-left"
      cell-class="table-component__text-left"/>
    <table-column
      :label="$t('health.nutritionalPlan.weekDays.monday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.monday) }">{{ getIntensityLabel(row.monday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.tuesday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.tuesday) }">{{ getIntensityLabel(row.tuesday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.wednesday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.wednesday) }">{{ getIntensityLabel(row.wednesday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.thursday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.thursday) }">{{ getIntensityLabel(row.thursday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.friday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.friday)}">{{ getIntensityLabel(row.friday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.saturday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.saturday) }">{{ getIntensityLabel(row.saturday) }}</div>
      </template>
    </table-column>

    <table-column
      :label="$t('health.nutritionalPlan.weekDays.sunday')"
      header-class="text-left"
      cell-class="table-component__text-left">
      <template slot-scope="row">
        <div class="rounded-cell" :style="{ background: selectedColor(row.sunday) }">{{ getIntensityLabel(row.sunday) }}</div>
      </template>
    </table-column>

  </table-component>
</template>

<script>
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';

export default {
  name: 'WeekPlanTable',
  components: {
    TableRow,
    TableComponent,
    TableColumn
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      colorOptions: [
        {label: this.$t('health.nutritionalPlan.colors.white'), value: 0, id: 0, color: '#f8f8f8'},
        {label: this.$t('health.nutritionalPlan.colors.green'), value: 1, id: 1, color: '#4e9d26'},
        {label: this.$t('health.nutritionalPlan.colors.yellow'), value: 2, id: 2, color: '#fcca2d'},
        {label: this.$t('health.nutritionalPlan.colors.red'), value: 3, id: 3, color: '#ff4f4f'},
        {label: this.$t('health.nutritionalPlan.colors.purple'), value: 4, id: 4, color: '#A853F8FF'}
      ]
    };
  },
  methods: {
    getIntensityLabel (intensity) {
      if (intensity === null || intensity > this.colorOptions.length) {
        intensity = 0;
      }
      return this.colorOptions[intensity].label;
    },
    selectedColor (selected) {
      let color = this.colorOptions[0].color;
      if (selected != null) {
        const data = this.colorOptions.find(data => data.value === selected);
        if (data) {
          color = data.color;
        }
      }
      return color;
    }
  }
};
</script>

<style scoped>
.rounded-cell {
  border-radius: 25px;
  border: 1px solid #464846;
  padding: 1%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/WeekPlanTable.vue